import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';


@connect(
  state => ({
    errors: state.ui.errors
  })
)
export default class ErrorsRoute extends PureComponent {
  render() {
    return (
      <div className="errors-route">
        <h1>Oops!</h1>
        <p>There were issues with your submission:</p>
        <Link to='/'>Back to the form</Link>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/errors-route/index.js